<div class="container-sm">

  <h2>Let's activate your account</h2>

  <p>Welcome <strong>{{ this.user?.name }}</strong>!<br>
    Let's set up your password so you can book tickets on behalf of <strong>{{ this.user?.company.name }}</strong>.
  </p>

  <form [formGroup]="form" #f="ngForm" (submit)="ok()">

    <div class="form-group">
      <label for="input-password">Password</label>
      <input type="password" class="form-control" id="input-password" name="password" autocomplete="new-password"
             formControlName="password"
             [class.is-invalid]="f.submitted && form.controls.password.invalid"
      >
      <div class="invalid-feedback" *ngIf="form.controls.password.hasError('required')">
        Please enter your password.
      </div>
      <div class="invalid-feedback" *ngIf="form.controls.password.hasError('minlength')">
        Your password must be at least {{ form.controls.password.errors.minlength.requiredLength }} characters.
      </div>
    </div>

    <div class="form-group">
      <label for="input-password-confirmation">Password, once more</label>
      <input type="password" class="form-control" id="input-password-confirmation" name="password" autocomplete="new-password"
             formControlName="passwordConfirmation"
             [class.is-invalid]="f.submitted && (form.errors || form.controls.passwordConfirmation.invalid)"
      >

      <div class="invalid-feedback" *ngIf="form.errors">
        The passwords are different.
      </div>
      <div class="invalid-feedback" *ngIf="form.controls.passwordConfirmation.hasError('required')">
        Please confirm your password.
      </div>

    </div>

    <button class="btn btn-success btn-block btn-lg">
      Activate my Account
    </button>

  </form>

</div>


